import handleAxiosError from 'utils/handleAxiosError'
import { PlanDetails } from 'types'
import api from 'data/plan_api.json'

export interface ClientPlanDataResponse {
	plans: PlanDetails[]
}

const getClientPlanData = async (): Promise<ClientPlanDataResponse> => {
	try {
		return api as ClientPlanDataResponse
	} catch (error: any) {
		handleAxiosError(error)
		throw error
	}
}
export default getClientPlanData
